export default {
    listagem: {
        titulo_pagina: 'List of Loincs',
        novo: 'Create New Loinc',
        table: {
            empty: 'No Loinc found',
            nome: 'Name',
            propriedade: 'Property',
            sistema: 'System',
            ordem_observacao: 'Order / Note',
            nome_longo: 'Long name',
            nome_curto: 'Short name',
            nome_exibicao: 'Display name',
            componente: 'Component',
            tempo: 'Time',
            escala: 'Scale',
            metodo: 'Method',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Loinc',
            editar: 'Edit Loinc'
        },
        fields: {
            loinc: {
                label: 'LOINC',
                description: 'Exam Loinc Code'
            },
            nome_longo: {
                label: 'Long Name',
                description: 'Loinc long name'
            },
            nome_curto: {
                label: 'Short Name',
                description: 'Loinc short name'
            },
            nome_exibicao: {
                label: 'Display Name',
                description: 'Loinc Display Name'
            },
            status: {
                label: 'Status',
                description: 'Loinc Status'
            },
            ordem_obs: {
                label: 'Order / Note',
                description: 'Loinc Type'
            },
            componente: {
                label: 'Component',
                description: 'Loinc Component'
            },
            propriedade: {
                label: 'Property',
                description: 'Loinc Property'
            },
            tempo: {
                label: 'Time',
                description: 'Loinc Time'
            },
            sistema: {
                label: 'System',
                description: 'Loinc System'
            },
            escala: {
                label: 'Scale',
                description: 'Loinc Scale'
            },
            metodo: {
                label: 'Method',
                description: 'Loinc Method'
            },
            botao_salvar : 'Save Loinc'
        },
        create: {
            success: 'Loinc successfully created!',
            error: 'Error creating Loinc!'
        },
        update: {
            success: 'Loinc successfully edited!',
            error: 'Error editing Loinc!'
        }
    },
    import: {
        csv: {
            titulo_pagina: 'Import LOINC CSV',
            tabs: {
                arquivo: {
                    label: 'Select the file',
                    escolha: 'Choose a file or drop one here...',
                    solte: 'Drop here...',
                    selecionado: 'Selected File',
                    botao_carregar: 'Upload CSV',
                    carregando: 'Loading file',
                    preparando: 'Preparing file',
                    enviando: 'Sending file',
                },
                criados: {
                    label: 'Created',
                    botao_todos: ''
                },
                atualizados: {
                    label: 'Updated',
                    botao_todos: ''
                }
            },
            lang: {
                titulo_pagina: 'Import Language LOINC CSV',
            },
            erro: {
                carregar: 'Error loading CSV',
                processar: 'Error processing CSV',
                enviar: 'Error sending part of CSV'
            }
        }
    }
}
